import HomePageFirstFeaturedPostCover from 'assets/images/temp/featured-post-cover.png';
import HomePageSecondFeaturedPostCover from 'assets/images/temp/featured-post-banner.png';
import PostThumb from 'assets/images/temp/post-thumb.png';
import PostThumb2 from 'assets/images/temp/post-thumb-2.png';
import PostThumb3 from 'assets/images/temp/post-thumb-3.png';
import PostThumb4 from 'assets/images/temp/post-thumbnail.png';
import PostThumb5 from 'assets/images/temp/post-thumb-5.png';
import PostThumb6 from 'assets/images/temp/post-thumb-6.png';
import PostThumb7 from 'assets/images/temp/post-thumb-7.png';

const hotTagsList = [
  {
    id: 'tags-1',
    name: 'Technology',
    link: '#',
  },
  {
    id: 'tags-2',
    name: 'Open Source',
    link: '#',
  },
  {
    id: 'tags-3',
    name: 'JavaScript',
    link: '#',
  },
  {
    id: 'tags-4',
    name: 'Minimalism',
    link: '#',
  },
  {
    id: 'tags-5',
    name: 'Self-help',
    link: '#',
  },
  {
    id: 'tags-6',
    name: 'Animals',
    link: '#',
  },
  {
    id: 'tags-7',
    name: 'Herbivores',
    link: '#',
  },
  {
    id: 'tags-8',
    name: 'HTML',
    link: '#',
  },
  {
    id: 'tags-9',
    name: 'CSS',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'PHP',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Web Technologies',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Career',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Life',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Spirituality',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Food',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Cooking ',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Sports ',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Racing',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Mountain',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Hiking',
    link: '#',
  },
  {
    id: 'tags-10',
    name: 'Cruising',
    link: '#',
  },
];

const HomePageFirstFeaturedPost = {
  tags: 'Featured Article',
  title: 'World’s Most Dangerous Technology Ever Made.',
  link: '#first-link',
  author: 'Ralph Hawkins',
  createdAt: 'May 7, 2019',
  excerpt: `Proident aliquip velit qui commodo officia qui consectetur dolor
    ullamco aliquip elit incididunt. Ea minim ex consectetur excepteur. Ex
    laborum nostrud mollit sint consectetur Lorem amet aliqua do enim.
    Commodo duis dolor anim excepteur. In aliquip mollit nulla consequat
    velit magna.`,
  timeToRead: '10 mins read',
  cover: HomePageFirstFeaturedPostCover,
};

const HomePageSecondFeaturedPost = {
  title: 'Laborum Ullamco Sunt id ut Sunt',
  tags: 'Interior',
  author: 'Bessie Hawkins',
  createdAt: 'May 7, 2019',
  excerpt:
    'Proident aliquip velit qui commodo officia qui consectetur dolor ullamco aliquip elit incididunt. Ea minim ex consectetur excepteur. Ex laborum nostrud mollit sint consectetur Lorem amet aliqua do enim. Commodo duis dolor anim excepteur. In aliquip mollit nulla consequat velit magna.',
  timeToRead: '10 mins',
  link: '#second-link',
  cover: HomePageSecondFeaturedPostCover,
};

const homepagePostList1 = [
  {
    id: 'spl-1',
    title: 'Culpa sit Laboris Exercitation ea Fugiat',
    tags: 'Nature',
    cover: PostThumb4,
    author: 'Leslie Pena',
    excerpt:
      'Incididunt occaecat et qui dolore consectetur magna. Lorem veniam ut et labore consequat ut ex sunt. Ut et nostrud aliquip do anim proident ad nulla consectetur eu aute ex anim mollit. Anim aute exercitation nisi fugiat. Dolor velit excepteur commodo proident nulla commodo ullamco labore et esse.',
    createdAt: 'November 3, 2012',
    timeToRead: '6 mins',
    link: '#post-link',
  },
  {
    id: 'spl-2',
    title: 'Amet non Ex Officia nulla Cupidatat',
    tags: 'Technology',
    cover: PostThumb3,
    author: 'Jacob Henry',
    excerpt:
      'Sint anim Lorem aute duis Lorem incididunt. Nulla nostrud irure id ipsum aute excepteur duis sint. Do occaecat sit dolor magna esse. Mollit incididunt cillum consectetur fugiat adipisicing dolor est id minim amet cillum esse Lorem. Deserunt non duis excepteur aliqua duis eu reprehenderit.',
    createdAt: 'September 27, 2017',
    timeToRead: '8 mins',
    link: '#post-link',
  },
  {
    id: 'spl-3',
    title: 'Dolor ex Tempor Cotur Culpa li',
    tags: 'Article',
    cover: PostThumb5,
    author: 'Darrell Lane',
    excerpt:
      'Incididunt sint nulla eu adipisicing eu reprehenderit proident consequat est. Nisi consectetur incididunt mollit officia ut cupidatat laborum proident eu velit Lorem deserunt deserunt voluptate. Proident nostrud laborum reprehenderit culpa irure id labore do ad do minim nisi. Incididunt ex.',
    createdAt: 'May 16, 2017',
    timeToRead: '3 mins',
    link: '#post-link',
  },
];

const homepagePostList2 = [
  {
    id: 'pl-1',
    title: 'Tempor deserunt Sunt Qui',
    tags: 'Nature',
    cover: PostThumb,
    author: 'Connie Robertson',
    excerpt:
      'Ea qui dolor aute cupidatat ad pariatur proident. Mollit nulla tempor aute reprehenderit ut dolore mollit nisi consequat excepteur ex officia pariatur irure.',
    createdAt: 'November 3, 2012',
    link: '#post-link',
  },
  {
    id: 'pl-2',
    cover: PostThumb6,
    title: 'Tempor deserunt Sunt Qui',
    tags: 'Nature',
    author: 'Connie Robertson',
    excerpt:
      'Ea qui dolor aute cupidatat ad pariatur proident. Mollit nulla tempor aute reprehenderit ut dolore mollit nisi consequat excepteur ex officia pariatur irure.',
    createdAt: 'November 3, 2012',
    link: '#post-link',
  },
  {
    id: 'pl-3',
    title: 'Tempor deserunt Sunt Qui',
    tags: 'Nature',
    cover: PostThumb7,
    author: 'Connie Robertson',
    excerpt:
      'Ea qui dolor aute cupidatat ad pariatur proident. Mollit nulla tempor aute reprehenderit ut dolore mollit nisi consequat excepteur ex officia pariatur irure.',
    createdAt: 'November 3, 2012',
    link: '#post-link',
  },
  {
    id: 'pl-4',
    title: 'Tempor deserunt Sunt Qui',
    tags: 'Nature',
    cover: PostThumb2,
    author: 'Connie Robertson',
    excerpt:
      'Ea qui dolor aute cupidatat ad pariatur proident. Mollit nulla tempor aute reprehenderit ut dolore mollit nisi consequat excepteur ex officia pariatur irure.',
    createdAt: 'November 3, 2012',
    link: '#post-link',
  },
];
export {
  hotTagsList,
  homepagePostList2,
  HomePageFirstFeaturedPost,
  homepagePostList1,
  HomePageSecondFeaturedPost,
};
